import { render, staticRenderFns } from "./ManagerRelatedRecords.vue?vue&type=template&id=f167e722&scoped=true&"
import script from "./ManagerRelatedRecords.vue?vue&type=script&lang=js&"
export * from "./ManagerRelatedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f167e722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
